import Translator from 'bazinga-translator';
import type { TransParams } from './common';

export const transChoice = (
    id: string,
    num: number,
    params?: TransParams,
    domain = 'messages',
): string => Translator.transChoice(id, num, params, domain);
